<template>
  <button class="buy-now__shared highlighted" :disabled="showChainWarning" @click="mintButtonClicked()">MINT</button>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: ['collection', 'mint'],
  data: () => ({
    numberToMint: 1
  }),
  computed: {
     ...mapState({
       showChainWarning: state => state.ui.showChainWarning
     })
  },
  methods: {
    async mintButtonClicked() {
      const { error, txHash } = await this.mint(this.numberToMint)

      if(error) return

      if (txHash) {
        this.$router.push({ path: `/${this.$route.params.partner_slug}/collections/${this.collection.slug}/purchase/${txHash}` })
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
